export var FormsData = [
    {
        id : 0,
        formSequenceNum: 0,
        isActive : true,
        title : "General Information and Company Profile",
        formSubmissionType : "Multiple", // Single
        reportingGroupAccess : ["Mining Companies","Oil & Gas Companies"],
        reportingEntityAccess : [],
        formFields : [
            {
                id : 0,
                inputType : "text",
                fieldGroup : "",
                fieldOptions : [],
                label : "Name of Company",
                name : "Name of Company",
                field: "nameOfcompany",
                required : true
            },
            {
                id : 1,
                inputType : "text",
                fieldGroup : "Project Details",
                fieldOptions : [],
                label : "Province/s",
                name : "Location of Company Projects",
                field: "companyProjectLocationProvince",
                required : true
            },
            {
                id : 2,
                inputType : "text",
                fieldGroup : "Project Details",
                fieldOptions : [],
                label : "Municipality/ies",
                name : "Location of Company Projects",
                field: "companyProjectLocationMunicipality",
                required : true
            },
            {
                id : 3,
                inputType : "text",
                fieldGroup : "Project Details",
                fieldOptions : [],
                label : "Barangay/s",
                name : "Location of Company Projects",
                field: "companyProjectLocationBrgy",
                required : true
            },
            {
                id : 4,
                inputType : "text",
                fieldGroup : "",
                fieldOptions : [],
                label : "Address of Company's Principal Office",
                name : "Address of Company's Principal Office",
                field: "principalOfficeAddress",
                required : true
            },
            {
                id : 5,
                inputType : "textarea",
                fieldGroup : "",
                fieldOptions : [],
                label : "Board members of listed entities",
                name : "Board members of listed entities",
                field: "boardMembers",
                required : true
            },
            {
                id : 6,
                inputType : "textarea",
                fieldGroup : "",
                fieldOptions : [],
                label : "Listed owners of the Company",
                name : "Listed owners of the Company",
                field: "listedOwners",
                required : true
            },
            {
                id : 7,
                inputType : "text",
                fieldGroup : "",
                fieldOptions : [],
                label : "TIN",
                name : "TIN",
                field: "tin",
                required : true
            },
            {
                id : 8,
                inputType : "text",
                fieldGroup : "",
                fieldOptions : [],
                label : "Enumeration of existing MoAs with IPs",
                name : "Enumeration of existing MoAs with IPs",
                field: "existingMoas",
                required : true
            }
        ]
    },
    {
        id: 1,
        formSequenceNum: 1,
        isActive : true,
        title: "Bureau of Internal Revenue",
        formSubmissionType: "Multiple",
        reportingGroupAccess: ["Mining Companies","Oil & Gas Companies"],
        reportingEntityAccess : [],
        formFields: [
            {
                id : 0,
                inputType : "decimal",
                fieldGroup : "",
                fieldOptions : [],
                label : "Excise tax on minerals",
                name : "Excise tax on minerals",
                field: 'exciseInTaxOnMinerals',
                required : true
            },
            {
                id : 1,
                inputType : "decimal",
                fieldGroup : "",
                fieldOptions : [],
                label : "Corporate income tax",
                name : "Corporate income tax",
                field: 'corporateIncomeTax',
                required : true
            },
            {
                id : 2,
                inputType : "decimal",
                fieldGroup : "",
                fieldOptions : [],
                label : "Improperly accumulated retained earnings tax (IAET)",
                name : "Improperly accumulated retained earnings tax (IAET)",
                field: 'iaet',
                required : true
            },
            {
                id : 3,
                inputType : "decimal",
                fieldGroup : "Withholding Taxes",
                fieldOptions : [],
                label : "Foreign shareholder dividends",
                name : "Foreign shareholder dividends",
                field: 'foreignShareholderDividends',
                required : true
            },
            {
                id : 4,
                inputType : "decimal",
                fieldGroup : "Withholding Taxes",
                fieldOptions : [],
                label : "Profit remittance to principal",
                name : "Profit remittance to principal",
                field: 'profitRemittanceToPrincipal',
                required : true
            },
            {
                id : 5,
                inputType : "decimal",
                fieldGroup : "Withholding Taxes",
                fieldOptions : [],
                label : "Royalties to claim owners",
                name : "Royalties to claim owners",
                field: 'royaltiesToClaimOwners',
                required : true
            },
            {
                id : 6,
                inputType : "decimal",
                fieldGroup : "Other Withholding Tax",
                fieldOptions : [],
                label : "Withholding tax on compensation paid, if any",
                name : "Other withholding taxes",
                field: 'withholdingTax',
                required : true
            }
        ]
    },
    {
        id: 2,
        formSequenceNum: 2,
        isActive : true,
        title: "Bureau of Customs",
        formSubmissionType: "Multiple",
        reportingGroupAccess: ["Mining Companies","Oil & Gas Companies"],
        reportingEntityAccess : [],
        formFields: [
            {
                id : 0,
                inputType : "decimal",
                fieldGroup : "",
                fieldOptions : [],
                label : "Custom Duties",
                name : "Custom Duties",
                field: 'customDuties',
                required : true
            },
            {
                id : 1,
                inputType : "decimal",
                fieldGroup : "",
                fieldOptions : [],
                label : "VAT on imported materials and equipment",
                name : "VAT on imported materials and equipment",
                field: 'vatOnImportedMaterials',
                required : true
            },
            {
                id : 2,
                inputType : "decimal",
                fieldGroup : "",
                fieldOptions : [],
                label : "Excise tax on imported goods (e.g. petroleum products)",
                name : "Excise tax on imported goods (e.g. petroleum products)",
                field: 'exciseInTaxOnImportedGoods',
                required : true
            }
        ]
    }
];

export var ValidationEntries = [];

export var LookupInputTypes = [
    "currency",
    "checkbox",
    "decimal",
    "date",
    "Date range (Start Date)",
    "Date range (End Date)",
    "dropdown",
    "dropdown (Reporting Groups)",
    "dropdown (Reporting Entities)",
    "integer",
    "radio",
    "text",
    "textarea"
];



// WEBPACK FOOTER //
// ./src/constants/FormsData.js